var render = function render(){var _vm=this,_c=_vm._self._c;return _c('three-step-approval',{attrs:{"api":"home-bill-delete-request","perm-prefix":"approve_delete_bill_home","columns":_vm.columns,"final-word":"ລຶບ","search-label":"ຄົ້ນຫາ: ຊື່, ເບີໂທ, CUS_, ເລກບິນ","final-confirm":(n) => `ລຶບບິນສາຍບ້ານ ${n} ໃບ? ບິນທີ່ລຶບແລ້ວຈະເຫັນຢູ່ໜ້າປະຫວັດ.`}})
}
var staticRenderFns = []

export { render, staticRenderFns }